import { useEffect, useState } from "@wordpress/element"
import { API } from '../API';
import TableEntidades from "./TableEntidades";
import TableNavigation from "./TableNavigation";
import Form from "./Form";
import EntidadesNotFound from "./EntidadesNotFound";
const { __ } = wp.i18n;

function Entidades({ filterEntidades }) {

  const blockAPI = new API({ filterEntidades });
  const defaultArgs = {
    posts_per_page: 5,
    filterByTaxonomy: false
  }

  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [entidades, setEntidades] = useState([]);
  const [collapsed, setCollapsed] = useState(true);

  const goToPage = (pageNumber) => {
    setPage(pageNumber);
    const query = { ...defaultArgs, page: pageNumber };
    blockAPI.loadContent(query).then(response => {
      setEntidades(response.data);
    });
  }

  const searchQuery = (query) => {
    const searchQuery = { ...defaultArgs, search: query };
    blockAPI.loadContent(searchQuery).then(response => {
      setEntidades(response.data);
      setTotalPages(response.totalPages);
    });
  }

  useEffect(() => {
    blockAPI.loadContent(defaultArgs).then(response => {
      setEntidades(response.data);
      setTotalPages(response.totalPages);
    });
  }, []);

  return (

    <>
      <a href="#" className="wp-button-link has-button-link-black-500-color is-underlined icon-arrow-up-right has-icon has-icon-before mb-2" onClick={() => setCollapsed(!collapsed)}>
        <span className="cta-title">
          {__('Lista de Entidades', 'bizum-website')}
        </span>

        <img src={`${scriptsData.themeUrl}/assets/images/icons-default/arrow-up2.svg`} alt="Activar Bizum" className={`icon-arrow-right ${collapsed ? 'rotate-180' : ''}`} />
      </a>
      <div className={collapsed ? 'is-collapsed' : ''}>
        <Form searchQuery={searchQuery} />
        {entidades.length > 0 ? (
          <>
            <TableEntidades entidades={entidades} />
            <TableNavigation page={page} totalPages={totalPages} goToPage={goToPage} />
          </>
        ) : (
          <EntidadesNotFound />
        )}
      </div>
    </>
  )
}

export default Entidades